import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "InstitucionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "InstitucionPage",
            ss: ss,
            ajax: {
                "url": ss.indexInstitucion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Ciudad', name: 'c.Ciudad', title: 'Ciudad' },
                { data: 'Institucion', name: 'i.Institucion', title: 'Institución' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            institucions: [],
            ciudads: [],
            tipoI: [],
            paiss: [],
            filteredCities: [],
            institucion: {},
            isLoading: false,
            errorBag: {},
            tiposinsts:[]
        };
    },
    methods: {

        getTipoInstitucion() {
            this.ss.listTipoInstitucion().then(
                (result) => {
                    let response = result.data;
                    this.tiposinsts = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },

        newInstitucion() {
            this.institucion = {};
            this.$refs['frm-institucion'].show();
        },
        filterCities() {
            // Obtiene el país seleccionado
            const selectedPais = this.institucion.Pais;
            // Filtra las ciudades correspondientes al país seleccionado
            this.filteredCities = this.ciudads.filter(city => city.Pais === selectedPais);
        },
        showInstitucion(id) {
            this.isLoading=true;
            this.ss.showInstitucion(id).then(
                (result) => {
                    let response = result.data;
                    this.institucion = response.data;
                    this.$refs['view-institucion'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        getCiudad() {
            this.ss.listCiudad().then(
                (result) => {
                    let response = result.data;
                    this.ciudads = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        
        getPais() {
            this.ss.listPais().then(
                (result) => {
                    let response = result.data;
                    this.paiss = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        editInstitucion() {
            this.$refs['frm-institucion'].show();
            this.$refs['view-institucion'].hide();
        },
        cancelInstitucion() {
            if (this.institucion.id) {
                this.$refs['view-institucion'].show();
            }
            this.$refs['frm-institucion'].hide();
        },
        saveInstitucion() {
            



            if(!this.institucion.Institucion){
                this.$swal({
                    title: "Datos Incompletos",
                    text: "Debe llenar el campo Institucion",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                })
                return;
            }


            if(!this.institucion.TipoInstitucion){
                this.$swal({
                    title: "Datos Incompletos",
                    text: "Debe seleccionar un Tipo Institucion",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                })
                return;
            }

            if(!this.institucion.Pais){
                this.$swal({
                    title: "Datos Incompletos",
                    text: "Debe seleccionar un Pais",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                })
                return;
            }

            if(!this.institucion.Ciudad){
                this.$swal({
                    title: "Datos Incompletos",
                    text: "Debe seleccionar una Ciudad",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                })
                return;
            }



            this.ss.storeInstitucion(this.institucion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-institucion'].hide();
                    this.$refs['datatable-institucion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteInstitucion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyInstitucion(this.institucion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-institucion'].hide();
                                this.$refs['datatable-institucion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },

        getCiudad2() {
            this.ss.list2Ciudad(this.institucion.Pais).then(
                (result) => {
                    let response = result.data;
                    this.ciudads = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },

        draw() {
            window.$('.btn-datatable-Institucion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showInstitucion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        }else{
            // this.getCiudad();
            this.getPais();
            this.getTipoInstitucion();
        }
    }
};
